import { isRequired, isEmail } from 'utils/validators';

const SCHEDULE_PASS_NAME = 'schedulePassForm';
const SCHEDULE_DATE_FORM = 'scheduleDateForm';

const validate = values => {
  const errors = {};

  if (values.participants && values.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    values.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one participant should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    values.participants &&
    values.participants.length
  ) {
    const availableParticipants = values.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    values.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Participants can’t exceed ${availableParticipants}`
      };
      errors.isMaxParticipantsErrors = true;
    }
  }

  if (values.scheduleType === SCHEDULE_DATE_FORM) {
    if (!values.multiDates?.startDate) {
      errors.startingDate = 'Starting date is required';
    }
  } else if (
    values.scheduleType !== SCHEDULE_PASS_NAME &&
    !values.startingDate &&
    (!values.multiDates?.startDate || !values?.multiDates.endDate)
  ) {
    errors.startingDate = 'Starting date is required';
    errors.multiDates = 'Starting date is required';
  }

  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.phone || '', true)) {
    errors.phone = 'Phone is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email || '', true)) {
    errors.email = 'Invalid email';
  }

  return errors;
};

export default validate;
